import { ConsumablesEvent } from '@experiences/telemetry';
import { useCallback } from 'react';

import { useTelemetryHelper } from '../../../../telemetry/TelemetryHelper';

// Only these units report a usage-view telemetry event (parity with the legacy card).
const viewUsageTelemetryMap = new Map<string, string>([
    [ 'RU', ConsumablesEvent.RuViewUsage ],
    [ 'AIU', ConsumablesEvent.AiuViewUsage ],
    [ 'APICALLS', ConsumablesEvent.ApiCallsViewUsage ],
]);

export const useViewUsageTelemetry = (consumableCode: string, tenantId?: string) => {
    const { logEvent } = useTelemetryHelper();
    return useCallback(() => {
        const telemetryEventName = viewUsageTelemetryMap.get(consumableCode);
        if (!telemetryEventName) {
            return;
        }
        if (tenantId) {
            logEvent(telemetryEventName, { CloudTenantId: tenantId });
        } else {
            logEvent(telemetryEventName);
        }
    }, [ consumableCode, logEvent, tenantId ]);
};
